var HM_TEAMS = [
  { id: "1", name: "Aarthy S", desgn: "Content Development", picture: "aarthy.jpg" },
  { id: "3", name: "Ananda Kumar A ", desgn: "Software Development", picture: "anand.jpg" },
  { id: "5", name: "Divya Srinivasan ", desgn: "Finance & Accounts", picture: "divya.jpg" },
  { id: "6", name: "Frank Tlaletsi ", desgn: "Customer Engagement", picture: "frank.jpg" },
  { id: "7", name: "Frank Van Schalkwyk ", desgn: "Customer Engagement", picture: "frankV.jpg" },
  { id: "8", name: "Gayathri H ", desgn: "Customer Engagement", picture: "gayathri.jpg" },
  { id: "9", name: "Geetha Ramanujam ", desgn: "Content Development", picture: "geetha.jpg" },
  { id: "10", name: "Jayapackiam T.N ", desgn: "Content Development", picture: "jaya.jpg" },
  { id: "11", name: "Jona Sherly ", desgn: "Software Development", picture: "jona-sherly.jpg" },
  { id: "12", name: "Luthando Makinza ", desgn: "Customer Engagement", picture: "luthando.jpg" },
  { id: "13", name: "Narayanan K ", desgn: "Quality Assurance", picture: "narayanan.jpg" },
  { id: "14", name: "Ndzalama Mabunda", desgn: "Tech Infrastructure", picture: "ndzalama.jpg" },
  { id: "15", name: "Padmini Ravi ", desgn: "Content Development", picture: "padmini.jpg" },
  { id: "16", name: "Pavithra R ", desgn: "Content Development", picture: "pavithra.jpg" },
  { id: "17", name: "Porsha Megan Norton ", desgn: "Customer Engagement", picture: "porsha.jpg" },
  { id: "18", name: "Raghul ", desgn: "Data Analysis", picture: "raghul.jpg" },
  { id: "19", name: "Sivakumar P ", desgn: "Human Capital Management", picture: "shiva.jpg" },
  { id: "20", name: "Tamizh Selvi N ", desgn: "Admin & Procurement", picture: "tamilselvi.jpg" },
  { id: "21", name: "Udaya Kumar K ", desgn: "Finance & Accounts", picture: "uday.jpg" },
  { id: "22", name: "Veenus Vivie B ", desgn: "Admin & Procurement", picture: "veenus.jpg" },
  { id: "23", name: "Venugopal G ", desgn: "Tech Infrastructure", picture: "venu.jpg" },
];


export default HM_TEAMS;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/HmTeams.js